module.exports = __webpack_public_path__ + "static/media/chinese_05.171d6172.jpg";